<script>
  import {getContext} from 'svelte';
  import {stringify} from 'query-string';
  import copy from 'copy-to-clipboard';
  import {IMAGES} from '@/const/images';
  import {mc} from '@/core';
  import {userInfo$} from '@/store/user';
  import Button from '@/widgets/Button.svelte';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');

  function handleBackToTop() {
    let l = window.pageYOffset || document.documentElement.scrollTop;
    const s = (l / 600) * 25; //路程/时间=s *25每隔25ms秒 动的路程
    const st = setInterval(function () {
      l -= s;
      if (l <= 0) {
        l = 0; //当l<=0时，设置l=0
        clearInterval(st);
      }
      document.body.scrollTop = l;
      document.documentElement.scrollTop = l;
    }, 25);
  }

  function handleShare() {
    const referralCode = $userInfo$.referralCode;
    const shareText = LG(lang.ImParticipatingIn) + location.origin + location.pathname + '?' + stringify({referralCode});
    if (copy(shareText)) {
      mc.send('toast', 'info', {message: 'Copied'});
      return;
    }
    mc.send('toast', 'error', {message: 'Failed'});
  }
</script>

<style>
  .wrap {
    width: 100%;
    background: #07050c;
  }
  .logo {
    top: 50px;
    left: 0;
  }

  @media screen and (min-width: 640px) {
    .main {
      margin: 0 auto;
      padding: 0 0 30px;
      width: 1200px;
    }
    .title {
      font-size: 32px;
    }
    .btn {
      display: flex;
      justify-content: center;
    }
    .common {
      margin-left: 20px;
    }
  }

  @media screen and (max-width: 640px) {
    .logo {
      display: none;
    }
    .main {
      margin: 0 auto;
      padding: 0 0 30px;
      width: 100%;
    }
    .title {
      font-size: 24px;
    }
    .btn {
      display: flex;
      flex-direction: column;
    }
    .primary {
      margin: auto;
      width: 80%;
    }
    .common {
      margin: 20px auto 0;
      width: 80%;
    }
  }
</style>

<div class="wrap">
  <div class="main pr">
    <img class="logo pa" width="124" height="28" src={IMAGES.LOGO_LIGHT} alt="phemex logo" />
    <div class="content df aic jcc">
      <div class="tc">
        <div class="title cf">{LG(lang.StartTradingOnPhemex)}</div>
        <div class="btn mt40 mb32">
          <div class="primary">
            <Button type="primary" minWidth="100%" on:click={handleBackToTop}>{LG(lang.BackToTop)}</Button>
          </div>
          <div class="common">
            <Button type="common" minWidth="100%" on:click={handleShare}>
              <i class="iconfont mr5">&#xe63a;</i>{LG(lang.Share)}
            </Button>
          </div>
        </div>
        <div class="f12 T4">{LG(lang.CopyRight)}</div>
      </div>
    </div>
  </div>
</div>
